import { useWorkspace, type ActiveWorkspace } from '../../lib/session';
import { OrganizationChecklist } from './admin/OrganizationChecklist';
import { UserChecklist } from './user/UserChecklist';
import styles from './ChecklistPage.module.css';

/**
 * `/setup/checklist` inside the shell (Topbar „Tasks" active): the organization checklist (Admin 11, F1) for admins
 * while it is visible, then the personal checklist (Onboarding Nutzer 13–15).
 */
export function ChecklistPage() {
  const onboarding = useWorkspace().onboarding as ActiveWorkspace['onboarding'] | undefined;
  return (
    <div className={styles.page}>
      {onboarding?.organizationChecklistVisible ? <OrganizationChecklist /> : null}
      <UserChecklist />
    </div>
  );
}
